import React, { Component } from "react"
import request from "axios"
import { geoMercator, geoPath, geoCentroid } from "d3-geo"
import { geoTimes } from "d3-geo-projection"
import { feature } from "topojson-client"
import {Motion, spring} from 'react-motion'
import DistrictDetails from './DistrictDetails';
import Navigator from './Navigator';
import Spinner from './Spinner';
import SvgMap from './SvgMap';
import ResultsProvider from './ResultsProvider';
import getShapeFromLocalMap from '../utils/getShapeFromLocalMap';
class Maps extends Component {
   constructor(props){
      super(props);
      this.initRender = [];
      this.changeType = this.changeType.bind(this);
      // mapsToLoad order is important, from innermost to outermost!
      this.mapData = [];
      this.mapsToLoad = ['circoscrizioni', 'regioni'];
      this.defaultCoords = [12.338021942602374,41.84718933156246];
      this.parentConfigPath = props.remotePath+'/static/json';
      this.maxZoomLevel = 2;
      this.initConfig={
         loading:true,
         zoomLevel:0,
         zoomDetail:1,
         zoomCoords:this.defaultCoords,
         mapsToRender:[],
         navigator:{},
         geo:null,
         errorMsg:null
      }
      this.state=this.initConfig;
   }
   componentDidMount(){
      this.appInit(this.props.branch);
   }
   componentWillReceiveProps(newProps){
      // reset everything to initial state and re-init app
      if(newProps.branch !== this.props.branch){
         this.setState(this.initConfig);
         this.appInit(newProps.branch);
      }
   }
   appInit(branch){
      
      // get all maps as promises, either via localstorage if present or via ajax
      this.mapsToLoad.forEach((map, index)=>{
         const storageKey = `ep19-${map}-${branch}`;
         const isMapInLocalstorage = localStorage.getItem(storageKey);
         let mapPromise = isMapInLocalstorage ? 
            this.getMapFromLocalStorage(storageKey) : 
            this.getMapViaAjax(branch, map, storageKey, index);
            this.mapData.push(mapPromise);
      })
      Promise.all(this.mapData).then(mapDataArray=>{
         // cant be sure about ordering of returning array 
         // so sort by order property to show map from innermost to outermost
         // in our render function 
         let mapsToRender = mapDataArray.sort((a, b) => b.order - a.order);
         // all maps retrieved and formatted, so save to state and let's go ...
         this.setState({mapsToRender});
         this.hideSpinner();
         this.notificateAmpIframe();
         this.initRender = mapsToRender;
      })
   }
   getMapFromLocalStorage(key){
      // retrieve formatted map data from localstorage as promise
      return new Promise((resolve, reject)=>{
         let mapInLocalStorage = localStorage.getItem(key);
         resolve(JSON.parse(mapInLocalStorage));
      })
   }
   getMapViaAjax(branch, map, storageKey, index){
      // load config files with parent id for every shape (not for circoscrizioni. They dont have parents!)
      return new Promise((resolve, reject)=>{
         let getMap = ()=> request.get(this.props.mapPath+'/'+map+'.json');
         request.all([getMap()]).then(request.spread((resp)=>{
            let formattedData = this.formatMapData(resp.data);
            let mapObj = {
               key: index,
               order: index,
               mapType : map,
               mapData : formattedData
            }
            let storageItem = JSON.stringify(mapObj);
               localStorage.setItem(storageKey, storageItem);
               
            resolve(mapObj);
         }))
      })
   }

   formatMapData(rawData){
      // preprocess raw map data before saving
      let mapType=Object.keys(rawData.objects)[0];
      let features = feature(rawData, rawData.objects[Object.keys(rawData.objects)[0]]).features;
      let shapes = features.map(feat=>{
         // get shape center coordinates
         feat.shapeCenterCoords= geoCentroid(feat);
         switch(mapType){
            case 'circoscrizioni':
            feat.shapeId=feat.properties.COD_CIRC;
            feat.label=feat.properties.DEN_CIRC;
            feat.navigator={
               circoscrizione:feat.properties.DEN_CIRC,
               regioni: null
            }
            break;
            case 'regioni':
               feat.parent = feat.properties.COD_RIP;
               feat.shapeId="R"+feat.properties.COD_REG;
               feat.label=feat.properties.DEN_REG;
               feat.levels = {
                  1 : feat.properties.COD_RIP
               }
               let circo_circ = getShapeFromLocalMap('europee',0,feat.parent);
               feat.navigator={
                  circoscrizione:circo_circ.label,
                  regioni:feat.properties.DEN_REG
               }
            break;
         }
         return feat
      });
      return shapes;
   }
   zoomIn(shape){
      let zoomLevel = this.state.zoomLevel >=2 ? 2 : this.state.zoomLevel+1;
      if(zoomLevel > 0){
         this.handleZoom(shape, zoomLevel, shape.shapeCenterCoords, shape.navigator);
      }
   }
   changeCoords(shape, coords, navigator){
      this.handleZoom(shape, this.state.zoomLevel, coords, navigator);
   }
   navBack(level, parent){
      const circoscrizione = level <=0 ? null : this.state.navigator.circoscrizione;
      const regioni = level <=1 ? null : this.state.navigator.regioni;
      const navigator = {circoscrizione, regioni};
      let coords = level === 0 ? this.defaultCoords : this.state.zoomCoords;
      let shape = this.state.geo.levels ? getShapeFromLocalMap(this.props.branch, level, this.state.geo.levels[level]) : (parent ? getShapeFromLocalMap(this.props.branch, level,this.state.geo.parent) : null);
      this.handleZoom(shape, level, coords, navigator);
   }

   handleZoom(geo, zoomLevel, zoomCoords, navigator){
      let zoomDetail;
      switch(zoomLevel){
         case 0:  zoomDetail = 1;            break;
         default: zoomDetail = zoomLevel*3;  break;
      }
      // split setState in 2 tranches to allow smooth zoom out animation
      this.setState({
         geo,
         zoomLevel, 
         navigator
      }, function(){
         // wrap in setTimeout 0 to avoid map misplacements
         setTimeout(()=>{
            this.setState({
               zoomCoords, 
               zoomDetail
            })
            this.notificateAmpIframe();
         }, 0)
      });
   }
   changeType(evt){
      // toogle map second level on select
      this.showSpinner();
      const secondLevel =  evt.target.value;
      // load map if needed or get from cache
      this.getMapData(this.props.branch, evt.target.value, (currentMap)=>{
         if(this.state.zoomLevel > 0){
            // we are already viewing map detail, so change currentMap too
            this.setState({currentMap, mapType: secondLevel, secondLevel});
         }else{
            // map has been cached, just save reference to second level map to show
            this.setState({secondLevel});
         }
         this.hideSpinner();
      });
   }
   setTitle(){
      const branch ='Circoscrizioni Europee';
      switch(this.state.mapType){
         case 'regioni':
         var type = 'Regioni';
         break;
         default:
         var type = 'Circoscrizioni Europee';
         break;
      }
      return `${branch} - ${type}`
   }
   showSpinner(){
      this.setState({loading:true})
   }
   hideSpinner(){
      this.setState({loading:false})
   }
   notificateAmpIframe(){
      // AMP IFRAME RESIZE (change iframe height on mobile)
      console.warn('amp iframe resize ', document.body.scrollHeight);
      window.parent.postMessage({
         sentinel: 'amp',
         type: 'embed-size',
         height: document.body.scrollHeight
      }, '*');
   }
   render() {
      let {
         loading, 
         zoomLevel, 
         zoomDetail, 
         zoomCoords, 
         mapsToRender, 
         navigator,
         geo
      } = this.state;
      return (
         <div className="mapWrapper">
         <Navigator
               zoomLevel = {this.state.zoomLevel}
               navBack = {this.navBack.bind(this)}
               navigator = {this.state.navigator}
            />
            <div className="ep19-svg-container">
               <ResultsProvider 
                  mapType={this.mapsToLoad[this.state.zoomLevel]}
                  remotePath={this.props.remotePath}
                  branch = {this.props.branch}
               >
               {(results) =>(
                  <React.Fragment>
                     <div className="absoluteMap">
                        {mapsToRender.map(map => {
                           if(zoomLevel<=map.order || map.order===1){
                              return(
                                 <SvgMap 
                                    key={map.key}
                                    order={map.order}
                                    mapData={map.mapData} 
                                    mapType={map.mapType}
                                    zoomLevel = {zoomLevel}
                                    zoomIn={this.zoomIn.bind(this)}
                                    changeCoords={this.changeCoords.bind(this)}
                                    zoomCoords={zoomCoords}
                                    zoomDetail={zoomDetail}
                                    maxZoomLevel={this.maxZoomLevel}
                                    navigator = {navigator}
                                    branch= {this.props.branch}
                                    currentShape = {geo ? geo.shapeId : null}
                                    isNarrowWidth = {this.props.isNarrowWidth}
                                    results = {results.data[this.props.branch][map.mapType]}
                                 />
                              )
                           }
                        })}
                     </div>
                     <div className="mapDetails">
                        <DistrictDetails 
                        {...geo} 
                        mapsToLoad={this.mapsToLoad}
                        zoomLevel = {this.state.zoomLevel}
                        branch = {this.props.branch}
                        results={results}
                        logoPath={this.props.logoPath}
                        visible={geo ? true : false}
                        />
                     </div>
                  </React.Fragment>
               )}
               </ResultsProvider>
            </div>
            <Spinner enabled={loading} />
         </div>
      );
   }
}
export default Maps;



// WEBPACK FOOTER //
// ./src/components/Maps.js